export default __webpack_public_path__ + "static/media/partner-area.45a78c83.png";